<div class="landing" [style.background-color]="config.general?.background_color">
  <div class="landing-container">
    <header
      class="landing-header"
      [style.background-color]="config.header?.background_color"
      [style.color]="config.header?.text_color"
    >
      <img *ngIf="config.header?.image" [src]="config.header.image" alt="logo" />
      <h1>{{ config.header?.title }}</h1>
    </header>

    <main class="landing-body">
      <img *ngIf="config.body?.image" class="landing-banner" [src]="config.body.image" alt="banner" />

      <section class="landing-section" *ngFor="let section of sections">
        <h2 [style.color]="section.color">{{ section.name }}</h2>

        <div class="landing-cards">
          <article class="landing-card" *ngFor="let form of section.forms">
            <h3>{{ form.number }}</h3>
            <p [title]="form.title">{{ form.title }}</p>
            <p class="landing-card-subtitle" *ngIf="form.subtitle">{{ form.subtitle }}</p>
            <button type="button" class="landing-card-action" (click)="selectForm.emit(form)">
              <span>Diligenciar</span>
              <span class="material-icons">arrow_forward</span>
            </button>
          </article>
        </div>
      </section>
    </main>
  </div>
</div>
